import axios from 'axios';
import { API_URL } from '../constants/config';

export const getInitialTranslations = (params) => {
  // console.log(params.url, 'params.url');
  return axios.request({
    url: params.url,
    method: 'get',
  });
};

export const getTranslationsForModule = (params) => {
  const folder = params.folder || 'default';
  const module = params.module || 'common';
  const langURL = params.langSrcUrl || API_URL || `${window.location.origin}/`;
  return fetch(`${langURL}languages/${folder}/${params.lang}/${module}.json`)
    .then(response => response.json())
    .then((response) => {
      const language = { data: {} };
      if (Object.keys(response).length > 0) {
        Object.keys(response).forEach(function (key) {
          language.data[key] = typeof response[key] === 'object' ? response[key]['label'] : response[key];
        });
      }
      return language;
    });
};
